import Home from '../views/Home.vue';
import PageNotFound from '../errors/PageNotFound.vue';

export default [
    {
        path: '/',
        component: Home
    },
    {
        path: "*", component: PageNotFound
    }
];
